import React from "react";
import { Route, Redirect, RouteProps } from "react-router";
import { useRootStoreSelector } from "../store/hooks/useRootStoreSelector";

export const AuthenticatedRoute = ({ component, ...rest }: RouteProps) => {
  const user = useRootStoreSelector(state => state.user);
  const ComponentToRender: any = component;

  return (
    <Route
      {...rest}
      render={props =>
        user.authenticated ? (
          <ComponentToRender {...props} />
        ) : (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }
    />
  );
};
